import { Flex, FormControl } from '@chakra-ui/react'
import { ModalBase } from '../../../../../components/ModalBase'
import { useState, useEffect } from 'react'
import { iAvaliado } from '../..'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { InputCmp } from '../../../../../components/InputCmp'

interface iModal {
  isOpen: boolean
  avaliado?: iAvaliado
  dataFimUltimoEncerrado?: string
  onRequestClose: () => void
  onConfirm: (data: string, dataFim: string, reenviar: boolean) => void
}

export const ModalConfiguracao: React.FC<iModal> = ({ isOpen, avaliado, dataFimUltimoEncerrado, onRequestClose, onConfirm }) => {
  const [Data, setData] = useState('')
  const [DataFim, setDataFim] = useState('')

  function FormatarData(data: string): string {
    const [day, month, yearTime] = data?.split('/') ?? []
    if (yearTime === undefined || yearTime === null) return ''
    const [year, Time] = yearTime.split(' ')
    return year + '-' + month + '-' + day + ' ' + Time
  }

  useEffect(() => {
    setData(FormatarData(avaliado?.dataInicio ?? ''))
    setDataFim(FormatarData(avaliado?.dataFim ?? ''))
  }, [avaliado])

  return (
        <ModalBase
            isOpen={isOpen}
            onClose={onRequestClose}
            Width="40rem"
            Titulo='Configuracões'
        >
            <Flex flexDir={'column'} padding={'1rem'}>
                <Flex gap={'.75rem'}>
                    <FormControl>
                        <InputCmp
                            label='Data de início'
                            value={Data}
                            OnChange={(e) => setData(e)}
                            type={'datetime-local'}
                            max={'2099-12-31T23:59'}
                            // min={dataFimUltimoEncerrado !== undefined ? converterData(dataFimUltimoEncerrado.substring(0, 10), 1).toISOString().split('T')[0] + 'T00:00:00' : ''}
                        />
                    </FormControl>

                    <FormControl>
                        <InputCmp
                            label='Data de fim'
                            value={DataFim}
                            OnChange={(e) => setDataFim(e)}
                            type={'datetime-local'}
                            max={'2099-12-31T23:59'}
                        />
                    </FormControl>
                </Flex>
                <Flex justifyContent={'end'} gap='.5rem' marginTop={'1rem'}>
                    <ButtonCmp VarColor='c6' onClick={onRequestClose}>Cancelar</ButtonCmp>
                    <ButtonCmp VarColor='Rosa' onClick={() => onConfirm(Data, DataFim, false)}>Salvar</ButtonCmp>
                    {
                        (avaliado?.iniciada) && (
                            <ButtonCmp
                                VarColor='Green2'
                                onClick={() => onConfirm(Data, DataFim, true)}
                            >Salvar e reenviar para os não respondidos</ButtonCmp>
                        )
                    }
                </Flex>
            </Flex>
        </ModalBase>
  )
}
